import TransformComponent from '../../../Component/Transform';
import { Easing } from '@tweenjs/tween.js';
import AnimationClip from '../AnimationClip';
import { getCardHandler } from '../../Card/CardSystem';
import BaseCardHandler from '../../Card/Handler/BaseCardHandler';
import BaseCard from '../../../Prototype/Level/Card/BaseCard';
import SpriteComponent from '../../../Component/Render/Sprite';
import { CardType } from '../../../Prototype/Level/Card/CardType';

export class CardFlip extends AnimationClip {
    public *execute(
        gameObject: BaseCard,
        meta?: any
    ): IterableIterator<number> {
        const transform: TransformComponent = gameObject.getComponent(
            TransformComponent
        );

        if (meta.system) {
            // If it's a card value make sure that front sprite is updated.
            // When there is a task and the value was changed, the value shown
            // is the previous one and it'll be updated only in the next action.
            const cardState = meta.system.state.getState().levelState.cardsState
                .cards[gameObject.id];

            if (cardState.type === CardType.value) {
                gameObject
                    .getChildByName('cardFrontSprite')
                    .getComponent(
                        SpriteComponent
                    ).texture = `card${cardState.value + 1}`;
            }
        }

        // Reset rotation.
        if (meta.rotation) {
            transform.rotation = meta.rotation;
        }

        const tweenIn = this.getTween(transform.scale);

        tweenIn.to({ x: 0 }, 150).easing(Easing.Quadratic.In);

        yield* this.startTween(tweenIn);

        const tweenOut = this.getTween(transform.scale);
        const handler: BaseCardHandler = getCardHandler(gameObject);
        handler.setCardFaceUp(meta.faceUp);
        tweenOut.to({ x: 1 }, 150).easing(Easing.Quadratic.Out);

        yield* this.startTween(tweenOut);
    }
}
